import React from 'react';
import { instanceOf } from 'prop-types';
import { connect } from 'react-redux';

import DictionaryList from './DictionaryList';

const DictionaryBox = ({ invalid, dictionary }) => {
  let renderDictionary = <div>No record found.</div>;
  if (dictionary) {
    renderDictionary = <DictionaryList />;
  }

  return (
    <div className="ie--card">
      <div className="ie--card--body">
        <div className="ie--card--col">
          <h2 className="ie--card--title">Dictionary Text</h2>
          <div className="ie--dictionary--info">
            <p>
              Personalize your survey. This tells us how you want to identify
              the data in MRI-Simmons Insights platform. Please edit
              pre-populated text for each question and answer options. The
              dictionary text has a limit of <strong> 35 characters</strong> and
              no special characters allowed.
            </p>
          </div>
          {invalid.specialChar.length > 0 && (
            <div className="ie--dictionary--generic-error">
              Error: Special Characters (@, /, {"',"} ? etc) are not allowed for
              dictionary text. Please edit the text.
            </div>
          )}
          {renderDictionary}
        </div>
      </div>
    </div>
  );
};

DictionaryBox.propTypes = {
  invalid: instanceOf(Object),
  dictionary: instanceOf(Object),
};

DictionaryBox.defaultProps = {
  invalid: {
    specialChar: [],
    maxLength: [],
  },
  dictionary: null,
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyQnO } = turnkeyOmnibus;
  return {
    invalid: surveyQnO.invalid,
    dictionary: surveyQnO.dictionary,
  };
};

export default connect(
  mapStateToProps,
  null
)(DictionaryBox);
